import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/vehicle";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import { Suspense } from "react";
import { Controller } from "react-hook-form";

export default function RegisterVehicleView({
  goBack,
  onChangeSelect,
  goToLogin,
  isDisabled,
  types,
  brands,
  models,
  isLoading,
  error,
  errorPlate,
  errorCustomer,
  errorCreateUser,
  handlePlate,
  register,
  handleSubmit,
  errors,
  isVisibleModal,
  toggleModal,
  control,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Dados do veículo"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div>
            <h2 className="mt-6 text-black text-xl">Dados do veículo</h2>
            <div className="flex flex-col justify-center">
              <InputMask 
                {...register("plate")}
                name="plate" 
                placeholder="Sua Placa" 
                className="uppercase mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14" 
                mask="___-.@.." 
                replacement={{ _: /\D/, ".": /\d/, "@": /[A-Za-z0-9]*/ }} 
                type="text"
              />
              {errors.plate && (
                <span className="text-red-500 text-xs">{errors.plate.message as string}</span>
              )}
              <Controller 
                control={control}
                name="type"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Tipo do veículo" 
                    name="type" 
                    className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14">
                      <option value="0">Tipo do veículo</option>
                      {types?.map((item, index) => (
                        <option key={index} value={item.id}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.type && (
                <span className="text-red-500 text-xs">{errors.type.message as string}</span>
              )}
              <Controller 
                control={control}
                name="brand"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Marca" 
                    name="brand" 
                    className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14">
                      <option value="0">Marca</option>
                      {brands?.map((item, index) => (
                        <option key={index} value={item.value}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.brand && (
                <span className="text-red-500 text-xs">{errors.brand.message as string}</span>
              )}
              <Controller 
                control={control}
                name="model"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Modelo" 
                    name="model" 
                    className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14">
                      <option value="0">Modelo</option>
                      {models?.map((item, index) => (
                        <option key={index} value={item.value}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.model && (
                <span className="text-red-500 text-xs">{errors.model.message as string}</span>
              )}
            </div>
          </div>
          <Button 
            title="Continuar"
            type="submit"
            isDisabled={isDisabled}
          />
        </form>
      </main>
      {error && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Ops!"
          message="Houve um problema ao validar sua placa, quer tentar novamente?"
          actionMessage="Tentar novamente"
          action={() => {
            toggleModal();
            handlePlate();
          }}
          actionSecondMessage="Não!"
          actionSecond={toggleModal}
        />
      </Suspense> }
      {errorPlate && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Atenção!"
          message="Esse veículo já possui um meio de pagamento automático cadastrado, não é possível adicionar ao Pedágio Eletrônico Sem Parar."
          actionMessage="Ok!"
          action={toggleModal}
        />
      </Suspense>}
      {errorCustomer && isVisibleModal && <Suspense fallback={null}>  
        <Modal
          title="Atenção!"
          message="Você já é nosso cliente."
          actionMessage="Login"
          action={() => {
            toggleModal();
            goToLogin();
          }}
        />
      </Suspense>}
      {errorCreateUser && isVisibleModal && <Suspense fallback={null}>  
        <Modal
          title="Ops!"
          message="Houve um problema, quer tentar novamente?"
          actionMessage="Tentar novamente"
          action={() => {
            toggleModal();
            handleSubmit();
          }}
          actionSecondMessage="Não"
          actionSecond={toggleModal}
        />
      </Suspense>}
      {isLoading && <Suspense fallback={null}>
        <Loading/>
      </Suspense>}
    </div>
  );
}
